import { Directive, HostBinding, HostListener, Optional } from '@angular/core';

import { DraggableDirective } from './draggable.directive';
import { DndEvent } from './utils';

@Directive({
  selector: '[pcsDndHandle]'
})
export class DndHandleDirective {

  @HostBinding('attr.draggable') draggable = true;

  constructor(@Optional() parent: DraggableDirective) {
    if (parent) {
      parent.registerDragHandle(this);
    }
  }

  @HostListener('dragstart', ['$event'])
  @HostListener('dragend', ['$event'])
  onDragEvent(event: DndEvent) {
    event._dndUsingHandle = true;
  }
}
